export default __webpack_public_path__ + "static/media/shapefiles.ec35b32e.png";